import { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Spinner, FloatingLabel, InputGroup, FormControl } from "react-bootstrap";
import { APIEditExplainer, APIGetExplainerData } from "../helper/APIFunctions";
import "./VisualModals/EditModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faLink } from "@fortawesome/free-solid-svg-icons";
import { pubchemValidator, pdbValidator } from "../helper/WebResourceValidators";

const EditExplainerModal = (props) => {
    const [initCallingAPI, setInitCallingAPI] = useState(false);
    const [isCallingAPI, setIsCallingAPI] = useState(false);
    const [editError, setEditError] = useState(null);
    const [slideState, setSlideState] = useState([]);
    const [title, setTitle] = useState("");
    const [secondaryText, setSecondaryText] = useState("");
    const [isTouched, setIsTouched] = useState(false);
    const [updatedState, setUpdatedState] = useState();
    const [invalidSlideIds, setInvalidSlideIds] = useState([]);

    useEffect(() => {
        if (!props.show) { return; }
        setInitCallingAPI(true);
        APIGetExplainerData(props.explainer.id, (data) => {
            setSlideState(data.slides);
            setTitle(data.title);
            setSecondaryText(data.secondary_text);
            setInitCallingAPI(false);
        }, (err) => {
            setEditError(err?.error || err || "Internal Server Error.");
            setInitCallingAPI(false);
        });
    }, [props.explainer.id, props.show]);
    const handleSave = () => {
        setIsCallingAPI(true);
        setEditError(null);
        const new_slideState = slideState.map((item) => ({
            ...item
        }));
        new_slideState.forEach((item, ind) => {
            if (item.id_raw) {
               delete item.id_raw;
            }
        });

        APIEditExplainer(props.explainer.id, { slides: new_slideState, title: title, secondary_text: secondaryText }, (data) => {
            setIsCallingAPI(false);
            props.onExplainerEdit({ slides: slideState, title: title, secondary_text: secondaryText });
            props.onHide();
        }, (err) => {
            setIsCallingAPI(false);
            setEditError(err?.error || err || "Internal Server Error.");
        });
    };
    return (
        <Modal show={props.show} onHide={props.onHide} centered className="edit-modal">
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title>Edit Explainer</Modal.Title>

            </Modal.Header>
            <Modal.Body>{initCallingAPI ? (
                <div className="text-center">
                    <Spinner animation="border" role="loading" className="text-secondary align-center" size="xl" />
                </div>
            ) : (<>
                {editError && (
                    <p className="text-danger text-center">{editError.toString()}</p>
                )}
                <Form.Group controlId="title">
                    <Form.Label>Title</Form.Label>
                    <Form.Control type="text" value={title} disabled={isCallingAPI} onChange={(e) => {
                        setTitle(e.target.value);
                        setIsTouched(true);
                    }} />
                </Form.Group>
                <Form.Group controlId="secondary-text">
                    <Form.Label>Disclaimer/Additional Text</Form.Label>
                    <Form.Control as="textarea" value={secondaryText} disabled={isCallingAPI} onChange={(e) => {
                        setSecondaryText(e.target.value);
                        setIsTouched(true);
                    }} />
                </Form.Group>
                {slideState && slideState.map((item, ind) => (
                    <div key={ind} className="mb-4">
                        <Form.Group controlId={`slide-${ind}-description`}>
                            <h3>Slide {ind + 1}</h3>
                            <Form.Label>Description</Form.Label>
                            <Form.Control as="textarea" value={item.description} disabled={isCallingAPI} onChange={(e) => {
                                const newState = [...slideState];
                                newState[ind].description = e.target.value;
                                setSlideState(newState);
                                setIsTouched(true);
                            }} />
                            {item.display_name && (<>
                                <Form.Label>Label Text</Form.Label>
                                <Form.Control type="text" value={item.display_name} disabled={isCallingAPI} onChange={(e) => {
                                    const newState = [...slideState];
                                    newState[ind].display_name = e.target.value;
                                    setSlideState(newState);
                                    setIsTouched(true);
                                }} />
                            </>
                            )}
                            {item.audio && (
                                <audio src={item.audio} controls />
                            )}
                            {item.id && ["molecule", "protein"].includes(item.type) && (
                                <>
                                <Form.Label>{item.type === "molecule" ? "PubChem CID" : "PDB ID"}</Form.Label>
                                    <Form.Control type="text" value={item.id_raw ?? item.id} disabled={isCallingAPI} isInvalid={invalidSlideIds.includes(ind)} onChange={(e) => {
                                        const newState = [...slideState];
                                        newState[ind].id_raw = e.target.value;
                                        const validationFunction = item.type === "molecule" ? pubchemValidator : pdbValidator;
                                        const validatedId = validationFunction(e.target.value);
                                        if (validatedId) {
                                        newState[ind].id = validatedId;
                                        setSlideState(newState);
                                        setInvalidSlideIds(invalidSlideIds.filter((id) => id !== ind));
                                        } else {
                                            setInvalidSlideIds([...invalidSlideIds, ind]);
                                        }
                                        setIsTouched(true);
                                    }} />
                                    <a href={item.type === "molecule" ? `https://pubchem.ncbi.nlm.nih.gov/compound/${item.id}` : `https://www.rcsb.org/structure/${item.id}`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLink} /></a>
                                    <Form.Control.Feedback type="invalid">
                                        Invalid {item.type === "molecule" ? "PubChem CID" : "PDB ID"}
                                    </Form.Control.Feedback>
                                </>
                            )}
                        </Form.Group>
                    </div>
                ))}
            </>
            )}
                <Button onClick={handleSave} disabled={!isTouched || isCallingAPI || !title.trim() || invalidSlideIds.length > 0}>{isCallingAPI ? <Spinner animation="border" role="loading" className="text-secondary align-center" size="sm" /> : 'Save'}</Button>
            </Modal.Body>
        </Modal>
    );
};

export default EditExplainerModal;